import type {ReactElement} from 'react';
import React from 'react';
import {defaultCountries, PhoneInput} from 'react-international-phone';
import 'react-international-phone/style.css';
import './phone-number-input.scss';
import type {PhoneInputChangeCallbackMetadata, PhoneNumberInputProps} from './phone-number-input.types';
import {DEFAULT_COUNTRY, PhoneNumberInputSize} from './phone-number-input.types';

export function PhoneNumberInput({phoneNumber, onInputChange, className = '', size = PhoneNumberInputSize.MEDIUM, ...phoneInputProps}: PhoneNumberInputProps): ReactElement<any> {
  const onChange = (updatedNumber: string, metaData?: PhoneInputChangeCallbackMetadata): void => {
    let newNumber = updatedNumber;
    if (updatedNumber === `+${metaData?.country.dialCode}`) {
      newNumber = updatePhoneNumberOnDialCodeSelect(phoneNumber, updatedNumber);
    }
    onInputChange(newNumber, metaData);
  };

  const updatePhoneNumberOnDialCodeSelect = (oldNumber: string, updatedNumber: string): string => {
    const allCountriesData = defaultCountries;
    for (let i = 0; i < allCountriesData.length; i++) {
      const data = allCountriesData[i];
      const dialCode = `+${data[2]}`;

      if (oldNumber.startsWith(dialCode)) {
        return oldNumber.replace(dialCode, updatedNumber);
      }
    }

    return updatedNumber;
  };

  return (
    <div className={`phone-number-input-container ${className} ${size === PhoneNumberInputSize.SMALL ? 'small' : 'medium'}`}>
      <PhoneInput
        value={phoneNumber}
        onChange={onChange}
        defaultCountry={phoneInputProps.defaultCountry ?? DEFAULT_COUNTRY}
        placeholder="+1 201 555-0123"
        className="phone-number-input"
        {...phoneInputProps}
      />
    </div>
  );
}
